/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadsFindAllResponse } from './LeadsFindAllResponse';
import {
    LeadsFindAllResponseFromJSON,
    LeadsFindAllResponseFromJSONTyped,
    LeadsFindAllResponseToJSON,
} from './LeadsFindAllResponse';

/**
 * 
 * @export
 * @interface FindAllLeads200Response
 */
export interface FindAllLeads200Response {
    /**
     * 
     * @type {LeadsFindAllResponse}
     * @memberof FindAllLeads200Response
     */
    data?: LeadsFindAllResponse;
}

/**
 * Check if a given object implements the FindAllLeads200Response interface.
 */
export function instanceOfFindAllLeads200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllLeads200ResponseFromJSON(json: any): FindAllLeads200Response {
    return FindAllLeads200ResponseFromJSONTyped(json, false);
}

export function FindAllLeads200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllLeads200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : LeadsFindAllResponseFromJSON(json['data']),
    };
}

export function FindAllLeads200ResponseToJSON(value?: FindAllLeads200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': LeadsFindAllResponseToJSON(value.data),
    };
}

